import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
const volumes = [{
  title: 'FOUNDATION PHASE',
  description: 'Build the essential basketball fundamentals through progressive training focused on ball handling, passing, shooting, finishing, coordination, and confidence.',
  meta: ['Basketball Fundamentals', 'Volume 1']
}, {
  title: 'SKILL DEVELOPMENT PHASE',
  description: 'Develop complete individual basketball skills with structured progressions in ball handling, shooting, footwork, finishing, passing, and 1v1 play.',
  meta: ['Individual Skills', 'Volume 2']
}, {
  title: 'GAME INTELLIGENCE PHASE',
  description: 'Teach players how to read the game, make better decisions, improve spacing, move without the ball, and develop basketball IQ.',
  meta: ['Basketball IQ', 'Volume 3']
}, {
  title: 'TEAM DEVELOPMENT PHASE',
  description: 'Transform individual players into a connected team by developing offensive concepts, defensive systems, transition play, communication, and competitive basketball.',
  meta: ['Team Play', 'Volume 4']
}, {
  title: 'THE 365 PRACTICE VAULT',
  description: 'Access a complete library of ready-to-use practice plans designed for every coaching situation, including low attendance, limited space, special events, and emergency sessions.',
  meta: ['Ready-To-Use Plans', 'Volume 5']
}, {
  title: 'COACH SUCCESS SYSTEM',
  description: 'Organize, lead, and manage your entire basketball season with practical systems for planning, player evaluation, leadership, parent communication, and long-term coaching success.',
  meta: ['Season Leadership', 'Volume 6']
}];
export function Volumes() {
  return <section className="relative bg-navy-950 py-12 md:py-20" data-id="element-279">
      <div className="container mx-auto px-4" data-id="element-280">
        <div className="mb-10 text-center md:mb-16" data-id="element-281">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-anton text-3xl uppercase tracking-wide text-white sm:text-4xl md:text-5xl" data-id="element-282">
            THE COMPLETE 6-VOLUME SYSTEM
          </motion.h2>
        </div>

        <div className="mx-auto grid max-w-6xl grid-cols-1 gap-4 md:grid-cols-2 md:gap-6 lg:grid-cols-3" data-id="element-283">
          {volumes.map((volume, index) => <motion.article key={volume.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group relative overflow-hidden rounded-xl border border-navy-700 bg-gradient-to-b from-navy-800 to-navy-900 p-5 sm:p-6 md:p-8" data-id="element-284">
              <BookOpen className="absolute right-0 top-0 h-24 w-24 p-4 text-white opacity-10" data-id="element-285" />
              <div className="relative z-10" data-id="element-286">
                <div className="mb-2 font-oswald text-xs tracking-wide text-gold-500" data-id="element-287">
                  VOLUME {index + 1}
                </div>
                <h3 className="mb-3 font-anton text-xl uppercase tracking-normal text-white md:mb-4 md:text-2xl md:tracking-wide" data-id="element-288">
                  {volume.title}
                </h3>
                <p className="mb-5 font-medium leading-relaxed text-gray-400" data-id="element-289">
                  {volume.description}
                </p>
                <div className="flex flex-wrap gap-2" data-id="element-290">
                  {volume.meta.map(item => <span key={item} className="inline-flex items-center rounded-full border border-gold-500/30 bg-gold-500/10 px-2.5 py-1 font-oswald text-[11px] uppercase tracking-wide text-gold-400 md:px-3 md:text-xs md:tracking-widest" data-id="element-291">
                      {item}
                    </span>)}
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}